<template>
  <WidgetWrapper
    :title="title"
    :full-height="true"
    v-loading="fullscreenLoading"
  >
    <hr class="mb-2 -mt-2" ref="UserLogHeader" />
    <SimpleTable
      :headers="headers"
      :items="items"
      :options="options"
      :page-size="view"
      :filter="filter"
      :search="filter.search"
      @initData="initData"
    />

    <div
      class="dx-datagrid-pager dx-pager"
      style="font-size: 10pt;"
      v-if="items.length"
    >
      <div class="dx-page-sizes">
        <div
          @click="view = 10"
          :class="{ 'dx-selection': view == 10 }"
          class="dx-page-size"
          role="button"
          aria-label="Display 10 items on page"
          tabindex="0"
        >
          10
        </div>
        <div
          @click="view = 20"
          :class="{ 'dx-selection': view == 20 }"
          class="dx-page-size"
          role="button"
          aria-label="Display 20 items on page"
          tabindex="0"
        >
          20
        </div>
        <div
          @click="view = 50"
          :class="{ 'dx-selection': view == 50 }"
          class="dx-page-size"
          role="button"
          aria-label="Display 50 items on page"
          tabindex="0"
        >
          50
        </div>
      </div>
      <div class="dx-pages"></div>
      <div class="dx-pages">
        <div class="dx-info">
          Page {{ start }} of {{ end }} ({{ total_data }} items)
        </div>
        <div
          class="dx-page"
          v-if="getPages[0] != 1"
          @click="items ? (page = 1) : null"
        >
          1
        </div>
        <div class="dx-separator" v-if="getPages[1] != 2 && total_data > view">
          . . .
        </div>
        <div
          class="dx-page"
          v-for="(page_number, index) in getPages"
          :class="{ 'dx-selection': page_number == page }"
          :key="index"
          @click="items ? (page = page_number) : null"
        >
          {{ page_number }}
        </div>
        <div
          class="dx-separator"
          v-if="getPages[getLastIndexArr(getPages)] < total_page - 1"
        >
          . . .
        </div>
        <div
          class="dx-page"
          v-if="getPages[getLastIndexArr(getPages)] != total_page"
          @click="items ? (page = total_page) : null"
        >
          {{ total_page }}
        </div>
      </div>
    </div>
  </WidgetWrapper>
</template>

<script>
import SimpleTable from '@/components/dx/TableLog'
import formHelper from './form-helper'
import WidgetWrapper from '@/components/WidgetWrapper'

export default {
  components: {
    SimpleTable,
    WidgetWrapper
  },
  beforeMount() {
    this.initData()
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      title: 'Audit Log - List',
      fullscreenLoading: false,
      headers: [
        { type: 'string', text: 'Username', value: 'machine_name', width: 200 },
        {
          type: 'string',
          text: 'Message',
          value: 'message'
        },
        {
          type: 'string',
          text: 'Data',
          value: 'data'
        },
        // { type: 'string', text: 'Callsite', value: 'callsite' },
        {
          type: 'date',
          text: 'Timestamp',
          value: 'logged_time',
          width: '170'
        },
        {
          type: 'string',
          text: 'Status',
          value: 'error_type',
          width: '150'
        }
      ],
      items: [],
      RecordsOnDuty: 0,
      options: {
        allowToRefetch: true
      },

      metadata: null,
      page: 1,
      page_array: [],
      total_page: 0,
      total_data: 0,
      view: 10,
      start: 1,
      end: 1,
      orderby: null,
      order: null,
      filter: null
    }
  },
  methods: {
    initData() {
      let search = []
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value != 'logged_time') {
          search.push({ key: this.headers[i].value, value: '' })
        }
      }
      this.filter = {
        orderby: 'logged_time',
        order: 'Desc',
        page: this.page,
        view: this.view,
        search: search
      }
    },
    getLastIndexArr(arr) {
      return arr.length - 1
    },

    async fetchData() {
      try {
        this.fullscreenLoading = true
        const res = await this.$axios.post(
          this.$appInfo.api.userlog.getFilter,
          this.filter
        )

        // let s = res.data.data.map((item) => {
        //   return {
        //     Id: item.id,
        //     ...item
        //   }
        // })

        // this.items = s

        this.items = res.data.data

        this.metadata = res.data.filter
        this.total_data = res.data.total_data
        this.start = 1 + (this.page * this.view - this.view)
        if (this.page * this.view > this.total_data) {
          this.end = this.total_data
        } else {
          this.end = this.page * this.view
        }
        this.fullscreenLoading = false
      } catch (e) {
        this.fullscreenLoading = false
        console.log(e)
      }
    }
  },
  watch: {
    view() {
      let get_page = null
      let page = this.total_data % this.view
      if (page == 0) {
        get_page = parseInt(this.total_data / this.view)
      } else {
        get_page = parseInt(this.total_data / this.view + 1)
      }
      if (this.page > get_page) {
        this.page = get_page
      }
      this.total_page = get_page
      this.items = []

      // if (this.search) {
      //   this.searchData(this.search, this.view, this.page);
      // } else {
      // this.fetchData()
      // }
      this.filter.view = this.view
    },
    total_data(val) {
      if (val) {
        this.total_page = Math.floor(val / this.view)
        if (this.total_page < val / this.view) {
          this.total_page += 1
        }
      } else {
        this.total_page = 0
      }
    },
    total_page(val) {
      this.page_array = []
      for (let i = 0; i < val; i++) {
        this.page_array.push(i + 1)
      }
    },
    page() {
      window.scroll({
        top: this.$refs.UserLogHeader.offsetTop,
        left: 0,
        behavior: 'smooth'
      })
      // setTimeout(() => (this.items = null), 500)
      // if (this.search) {
      //   this.searchData(this.search, this.view, this.page);
      // } else {
      // this.fetchData()
      // }
      this.filter.page = this.page
    },
    filter: {
      handler(val) {
        if (!this.fullscreenLoading) this.fetchData()
      },
      deep: true
    }
  },
  computed: {
    getPages() {
      let res = this.page_array.slice(
        this.page - 3 < 0
          ? 0
          : this.page + 1 <= this.total_page
          ? this.page - 3
          : this.total_page - 4 < 0
          ? 0
          : this.total_page - 4,
        this.page - 3 < 0 ? 4 : this.page + 1
      )
      return res
    }
  }
}
</script>

<style>
.dx-datagrid-header-panel .dx-toolbar {
  display: none !important;
}
</style>
